/**
 * Deployment markers shown in the top navbar (DeploymentBadge.vue).
 *
 * The active deployment comes from `VITE_DEPLOYMENT` (build/dev time, wins when
 * set) or from the persisted "directory" configuration (key: deployment), and
 * is matched here trimmed and lower-cased.
 *
 * Values that are not listed render no badge at all. That is deliberate: it
 * keeps "production" a valid value for switching the marker off, e.g. when an
 * acceptance database dump carrying `"deployment": "acceptance"` is restored
 * into a production instance.
 */
export const deploymentLabels: Record<string, string> = {
  acceptance: "Acceptance Server",
};

export default deploymentLabels;
